import { Playbook } from "../types";
import { useMemo } from "react";
import { topicTitlesMapper } from "../types/enums";

type TopicKey = keyof typeof topicTitlesMapper;

export const useGetPlaybookTitlesList = (playbook: Playbook | undefined) => {
  return useMemo(() => {
    if (!playbook) return [];

    return (Object.keys(topicTitlesMapper) as TopicKey[])
      .filter((key) => playbook[key])
      .map((key) => topicTitlesMapper[key]);
  }, [playbook]);
};
